import { OffersSellerComponent } from './offers-seller.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ offersSeller: OffersSellerComponent });
